import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthCard from "../components/AuthShell";
import { useAuth } from "../contexts/AuthContext";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (loading) return;
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/", { replace: true });
        } catch (err) {
            const msg = err?.response?.data?.detail;
            setError(typeof msg === "string" ? msg : "Credenziali non valide");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthCard
            title="Accedi"
            subtitle="Inserisci le tue credenziali per continuare."
            testId="login-shell"
        >
            <form onSubmit={onSubmit} method="post" action="#" noValidate data-testid="login-form">
                <label htmlFor="email" className="el-label">Email</label>
                <input
                    id="email"
                    className="el-field"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="nome@enerleft.it"
                    autoComplete="username"
                    required
                    data-testid="login-email-input"
                />

                <label htmlFor="password" className="el-label">Password</label>
                <input
                    id="password"
                    className="el-field"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••••"
                    autoComplete="current-password"
                    required
                    data-testid="login-password-input"
                />

                {error ? (
                    <div className="el-err" data-testid="login-error">{error}</div>
                ) : null}

                <button
                    type="submit"
                    className="el-btn"
                    disabled={loading}
                    onClick={onSubmit}
                    data-testid="login-submit-btn"
                >
                    {loading ? "Accesso…" : "Accedi"}
                </button>

                <div className="el-foot">
                    <Link to="/forgot-password" data-testid="forgot-password-link">
                        Password dimenticata?
                    </Link>
                </div>
            </form>
        </AuthCard>
    );
}
